import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from '@chakra-ui/react';
import { DatePickerCalendar } from './components/DatePickerCalendar';
import { DatePickerContent } from './components/DatePickerContent';
import { DatePickerWrapper } from './components/DatePickerWrapper';
import { DatePickerProvider } from './DatePickerContext';
export const DatePicker = forwardRef((props, ref) => {
    return (_jsx(DatePickerProvider, { ...props, innerRef: ref, children: _jsx(DatePickerWrapper, { children: _jsx(DatePickerContent, { children: _jsx(DatePickerCalendar, {}) }) }) }));
});
DatePicker.displayName = 'DatePicker';
